module.exports = __webpack_public_path__ + "media/images/number_12-80464588939b8000a7ff0979c6bb5ad9.png";